import { render, staticRenderFns } from "./Createdtype.vue?vue&type=template&id=3445b525&scoped=true"
import script from "./Createdtype.vue?vue&type=script&lang=js"
export * from "./Createdtype.vue?vue&type=script&lang=js"
import style0 from "./Createdtype.vue?vue&type=style&index=0&id=3445b525&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3445b525",
  null
  
)

export default component.exports